import styled, { css } from 'styled-components';

import Box from '../../../../_shared/components/Box';
import Icon from '../../../../_shared/components/Icon';
import Label from '../../../../_shared/components/Label';
import { SaleEventHeaderVariant } from '../../../../_shared/types/trade';

const saleEventHeaderVariant = {
  [SaleEventHeaderVariant.CONTINUED]: css`
    display: none;
  `
};

export const StyledBox = styled(Box.Column)`
  max-height: 192px;
  width: 100%;
  background: ${({ theme }) => theme.COLORS.BASE};
  display: flex;
  flex: 1 1 auto;
  border-radius: 3px 3px 0 0;
  border-left: 6px solid ${({ theme }) => theme.COLORS.TERTIARY};
  border-top: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
  border-right: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
`;

export const StyledRowBox = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  grid-column-gap: 80px;
  ${props => saleEventHeaderVariant[props.variant]}
`;

export const StyledColumnBox = styled(Box.Column).attrs(props => ({
  testId: props?.testId
}))`
  margin-bottom: 24px;
`;

export const StyledHeader = styled(Label.Bold)`
  margin: 24px 0px 26px 24px;
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  line-height: 16px;
`;

export const StyledVehicleCount = styled(Label.Bold)`
  margin-left: auto;
  margin-right: 24px;
  margin-top: 26px;
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  line-height: 16px;
`;

export const StyledEventName = styled(Label.Base)`
  margin-left: 24px;
  font-size: ${({ theme }) => theme.FONT_SIZES.XLARGE};
  line-height: 30px;
  margin-bottom: 24px;
  ${props => saleEventHeaderVariant[props.variant]}
`;

export const StyledContentHeader = styled(Box)`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  margin-left: 24px;
  margin-bottom: 9px;
  align-items: flex-start;
  justify-content: space-between;
  font-size: 16px;
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
`;

export const StyledContentBody = styled(Box)`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  margin-left: 24px;
  align-items: flex-start;
  justify-content: space-between;
  font-size: 16px;
  margin-right: 24px;
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
`;

export const StyledIcon = styled(Icon).attrs({
  icon: 'TR5-GroupNetwork'
})`
  width: 18px;
  height: 18px;
  margin-right: 14px;
`;
